<template>
  <div class="table-view">
    <!-- 主区 -->
    <div class="tv-main">
      <!-- 筛选行（参照云贝：区域管理一行排布，桌型过滤居中偏左） -->
      <div class="tv-filter-row">
        <div class="tv-area-row">
          <div class="area-pill" :class="{ active: activeArea === 0 }" @click="activeArea = 0">全部</div>
          <div v-for="a in areas" :key="a.id" class="area-pill"
               :class="{ active: activeArea === a.id }" @click="activeArea = a.id">{{ a.name }}</div>
        </div>
        <!-- 桌型过滤（名称(该型桌数)） -->
        <div class="tv-type-row">
          <div class="type-pill" :class="{ active: activeType === 0 }" @click="activeType = 0">全部</div>
          <div v-for="tt in typeTabs" :key="tt.id" class="type-pill"
               :class="{ active: activeType === tt.id }" @click="activeType = tt.id">{{ tt.name }}({{ tt.count }})</div>
        </div>
      </div>
      <!-- 桌台卡网格：灰未开台"N座"/绿已开台/橙就餐中"时长+人数+座位" -->
      <div class="tv-grid-scroll">
        <a-icon v-if="loading && tables.length === 0" type="loading" class="tv-loading" />
        <div class="tv-grid">
          <div v-for="t in filteredTables" :key="t.id" class="tcard"
               :class="[cardClass(t), { selected: t.id === selectedTableId }]" @click="onTableClick(t)">
            <div class="tcard-name">{{ t.name }}</div>
            <template v-if="t.status === '3'">
              <div class="tcard-status">就餐中</div>
              <div class="tcard-sub">就餐时长 {{ t.diningMinutes }}分钟</div>
              <div class="tcard-sub">{{ peopleOf(t) }}人 / {{ t.capacity || '-' }}座</div>
            </template>
            <template v-else-if="t.status === '2'">
              <div class="tcard-status">已开台</div>
            </template>
            <template v-else-if="t.status === 'reserved'">
              <div class="tcard-status">已预订</div>
            </template>
            <template v-else>
              <div class="tcard-seats">{{ t.capacity || '-' }}座</div>
            </template>
          </div>
        </div>
        <div v-if="!loading && filteredTables.length === 0" class="tv-empty">
          暂无桌台，请先在管理端配置桌台
        </div>
      </div>
      <!-- 底部：状态栏（上移独立一行） + 功能栏（云贝式上图标下文字，左操作/右主操作） -->
      <div class="tv-footer">
        <div class="tv-legend">
          <span class="lg-item"><i class="lg-dot lg-gray"></i>未开台</span>
          <span class="lg-item"><i class="lg-dot lg-green"></i>已开台</span>
          <span class="lg-item"><i class="lg-dot lg-orange"></i>就餐中</span>
        </div>
        <a-button type="primary" icon="reload" size="small" :loading="loading" @click="refreshAll">刷新</a-button>
        <span class="tv-foot-text">结算模式：{{ payModeText }}</span>
        <span class="tv-foot-text">点餐模式：{{ orderModeText }}</span>
      </div>
      <div class="tv-actionbar">
        <div class="ab-left">
          <div class="abtn" @click="handleClearAll">
            <a-icon type="delete" class="abtn-icon" /><span class="abtn-text">整单清空</span>
          </div>
          <div class="abtn" @click="openMemberModal">
            <a-icon type="team" class="abtn-icon" /><span class="abtn-text">会员</span>
          </div>
          <div class="abtn" @click="openChangePriceModal">
            <a-icon type="pay-circle-o" class="abtn-icon" /><span class="abtn-text">商品改价</span>
          </div>
          <div class="abtn" @click="openDiscountModal">
            <a-icon type="gift" class="abtn-icon" /><span class="abtn-text">折扣抹零</span>
          </div>
          <div class="abtn" @click="openChangeModal">
            <a-icon type="swap" class="abtn-icon" /><span class="abtn-text">转台</span>
          </div>
          <div class="abtn" @click="openDepositModal">
            <a-icon type="wallet" class="abtn-icon" /><span class="abtn-text">预收订金</span>
          </div>
          <div class="abtn" @click="handlePrintPreSettle">
            <a-icon type="printer" class="abtn-icon" /><span class="abtn-text">打印预结单</span>
          </div>
        </div>
        <div class="ab-right">
          <div class="abtn" @click="assistOrder">
            <a-icon type="edit" class="abtn-icon" /><span class="abtn-text">协助点餐</span>
          </div>
          <div class="abtn abtn-primary" @click="handleSettle">
            <a-icon type="pay-circle" class="abtn-icon" /><span class="abtn-text">结账</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 右侧信息面板 -->
    <div class="tv-side">
      <template v-if="selectedTable">
        <div class="side-title">桌台：{{ selectedTable.name }}</div>
        <div class="side-info">
          <div class="side-row"><span class="side-label">人数</span><span>{{ peopleOf(selectedTable) }}人</span></div>
          <div class="side-row"><span class="side-label">座位数</span><span>{{ selectedTable.capacity || '-' }}座</span></div>
          <div class="side-row"><span class="side-label">订单来源</span><span>{{ sourceOf(selectedTable) }}</span></div>
          <div v-if="selectedTable.status === '3'" class="side-row">
            <span class="side-label">就餐时长</span><span>{{ selectedTable.diningMinutes }}分钟</span>
          </div>
        </div>
        <!-- 就餐中桌：当前订单（菜品/金额/状态）+ 操作按钮 -->
        <template v-if="selectedOrder">
          <div class="side-order-head">
            <span class="side-order-no">{{ selectedOrder.order_no }}</span>
            <a-tag v-if="boundMember" color="gold" style="margin-left: 4px">{{ boundMember }}</a-tag>
            <a-tag :color="orderTagColor(selectedOrder.status)">{{ selectedOrder.statusText }}</a-tag>
          </div>
          <div class="side-items">
            <a-icon v-if="detailLoading" type="loading" class="side-loading" />
            <template v-else>
              <div v-for="it in selectedOrder.items" :key="it.id" class="side-item"
                   :class="{ 'side-item-active': it.id === selectedItemId, 'side-item-returned': isReturned(it) }"
                   @click="selectedItemId = it.id">
                <span class="si-name">{{ it.material_name }}</span>
                <span class="si-qty">x{{ it.quantity }}</span>
                <span class="si-amount">¥{{ fmt(it.all_price) }}</span>
                <a-tag v-if="isReturned(it)" color="red" class="si-returned-tag"
                       :title="it.return_reason || ''">已退</a-tag>
                <a-button v-else size="small" type="danger" ghost icon="rollback" class="si-return-btn"
                          @click.stop="openReturnModal(it)">退</a-button>
              </div>
              <div v-if="!selectedOrder.items || selectedOrder.items.length === 0" class="side-hint">暂无菜品，可点"加菜"开始点餐</div>
            </template>
          </div>
          <div class="side-total">
            <span>合计</span>
            <span class="side-total-amount">¥{{ fmt(selectedOrder.total_amount) }}</span>
          </div>
          <div class="side-actions">
            <!-- 手动接单（Task 7.3）：'1' 待接单单 + instore.receiving='2' 时显示 -->
            <a-button v-if="canReceive" block type="primary" icon="check"
                      :loading="receiving" @click="handleReceive">接单</a-button>
            <a-button block icon="plus" @click="gotoOrder(selectedTable.id, selectedOrder.id)">加菜</a-button>
          </div>
        </template>
        <div v-else-if="selectedTable.status === '3'" class="side-hint">桌台状态同步中，请刷新后重试</div>
        <div v-else class="side-hint">该桌台尚未开台，点击桌台卡片可开台点餐</div>
      </template>
      <div v-else class="side-default">
        <a-icon type="info-circle" class="side-default-icon" />
        <div>点选已开台桌台，可以在此查看点餐信息。</div>
      </div>
    </div>
    <!-- 开台弹窗：输入人数 + 选订单来源 -->
    <a-modal title="开台" :visible="openVisible" :confirm-loading="opening"
             :maskClosable="false" @ok="confirmOpen" @cancel="openVisible = false">
      <div v-if="openTable" class="open-form">
        <div class="open-row">
          <span class="open-label">桌台</span>
          <span>{{ openTable.name }}（{{ openTable.capacity || '-' }}座）</span>
        </div>
        <div class="open-row">
          <span class="open-label">人数</span>
          <a-input-number v-model="openPeople" :min="1" :max="99" :precision="0" />
        </div>
        <div class="open-row">
          <span class="open-label">订单来源</span>
          <a-select v-model="openSource" style="width: 180px">
            <a-select-option v-for="s in orderSources" :key="s" :value="s">{{ s }}</a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
    <!-- 转台弹窗（克隆云贝图5）：三级级联下拉（区域→桌型→空闲桌台），几十张桌场景精确锁定 -->
    <a-modal title="转台" :visible="changeVisible" :confirm-loading="changing"
             :maskClosable="false" @ok="confirmChange" @cancel="changeVisible = false">
      <div class="cascade-form">
        <div class="cascade-row">
          <span class="cascade-label"><i class="req">*</i>所属区域</span>
          <a-select v-model="changeAreaId" placeholder="请选择区域" style="flex: 1"
                    :getPopupContainer="trigger => trigger.parentElement"
                    @change="onChangeArea">
            <a-select-option v-for="a in areas" :key="a.id" :value="a.id">{{ a.name }}</a-select-option>
          </a-select>
        </div>
        <div class="cascade-row">
          <span class="cascade-label"><i class="req">*</i>桌位类型</span>
          <a-select v-model="changeTypeId" placeholder="请选择桌位类型" style="flex: 1"
                    :getPopupContainer="trigger => trigger.parentElement"
                    @change="onChangeType">
            <a-select-option v-for="tt in changeTypeOptions" :key="tt.id" :value="tt.id">
              {{ tt.name }}({{ tt.count }}张)
            </a-select-option>
          </a-select>
        </div>
        <div class="cascade-row">
          <span class="cascade-label"><i class="req">*</i>桌台编号</span>
          <a-select v-model="changeTargetId" placeholder="请选择空闲桌台" style="flex: 1"
                    :getPopupContainer="trigger => trigger.parentElement">
            <a-select-option v-for="t in changeTableOptions" :key="t.id" :value="t.id">
              {{ t.name }}（{{ t.capacity || '-' }}座）
            </a-select-option>
          </a-select>
        </div>
        <div class="change-tip">确定转台后，原桌将释放为未就餐状态，订单号保持不变</div>
      </div>
    </a-modal>

    <!-- 会员弹窗（三态：已绑=会员卡+解绑；预览=会员卡+确定/取消；输入=扫码/NumPad 查询） -->
    <a-modal title="查询会员" :visible="memberVisible" :footer="null" width="520px"
             :maskClosable="false" @cancel="memberVisible = false">
      <div class="member-tip">
        请输入会员手机号查询会员，输入完毕后点击确认<br>
        （若会员未绑定手机号，可通过会员手机号或通过扫码枪扫描二维码登录会员）
      </div>
      <div v-if="boundMemberInfo" class="member-card">
        <div class="member-card-row">
          <span class="member-card-name">{{ boundMemberInfo.name }}</span>
          <a-tag v-if="boundMemberInfo.levelName" color="gold">{{ boundMemberInfo.levelName }}</a-tag>
        </div>
        <div class="member-card-row member-card-sub">
          <span>手机号：{{ boundMemberInfo.phone || '—' }}</span>
          <span>余额：¥{{ fmt(boundMemberInfo.balance) }}</span>
        </div>
        <a-button block type="danger" :loading="memberLoading" @click="unbindMember">解绑会员</a-button>
      </div>
      <div v-else-if="memberQueryResult" class="member-card">
        <div class="member-card-row">
          <span class="member-card-name">{{ memberQueryResult.name }}</span>
          <a-tag v-if="memberQueryResult.levelName" color="gold">{{ memberQueryResult.levelName }}</a-tag>
        </div>
        <div class="member-card-row member-card-sub">
          <span>手机号：{{ memberQueryResult.phone || '—' }}</span>
          <span>余额：¥{{ fmt(memberQueryResult.balance) }}</span>
        </div>
        <div v-if="selectedOrder && selectedOrder.member_id" class="member-bound-hint">
          确定后将替换当前绑定会员
        </div>
        <div class="member-card-actions">
          <a-button size="large" @click="cancelMemberQuery">取消</a-button>
          <a-button size="large" type="primary" :loading="memberLoading" @click="confirmBindMember">确定</a-button>
        </div>
      </div>
      <template v-else>
        <div v-if="selectedOrder && selectedOrder.member_id" class="member-bound-hint">
          该订单已绑定会员，查询新会员后将替换绑定
        </div>
        <div class="np-input-row">
          <a-input ref="memberPhoneInput" v-model="memberPhone"
                   placeholder="请输入会员手机号（支持扫码枪）" class="np-input"
                   @keyup.enter.native="searchMemberByPhone">
            <a-icon slot="prefix" type="search" class="np-input-icon" />
          </a-input>
        </div>
        <num-pad v-model="memberPhone" :dot="false" @confirm="searchMemberByPhone" />
      </template>
    </a-modal>

    <!-- 商品改价弹窗（克隆云贝图2：当前价格蓝加粗 + *本次售价readonly+元后缀 + NumPad） -->
    <a-modal title="商品改价" :visible="priceVisible" :footer="null" width="520px"
             :maskClosable="false" @cancel="priceVisible = false">
      <div v-if="priceItem">
        <div class="np-field">
          <span class="np-field-label">当前价格</span>
          <span class="np-field-value np-blue">¥{{ fmt(priceItem.unit_price) }}</span>
        </div>
        <div class="np-field">
          <span class="np-field-label"><i class="req">*</i>本次售价</span>
          <div class="np-suffix-row">
            <a-input v-model="priceValue" readonly placeholder="0.00" class="np-input" />
            <span class="np-suffix">元</span>
          </div>
        </div>
        <num-pad v-model="priceValue" @confirm="confirmChangePrice" />
      </div>
      <div v-else class="side-hint">请先在右侧点选要改价的菜品行</div>
    </a-modal>

    <!-- 折扣抹零弹窗（克隆云贝图3/4：原价绿加粗+三单选蓝选中+改价/折扣NumPad+抹零规则大按钮） -->
    <a-modal title="折扣抹零" :visible="discountVisible" width="520px"
             :maskClosable="false" @cancel="discountVisible = false">
      <div class="np-field">
        <span class="np-field-label">原价</span>
        <span class="np-field-value np-green">¥{{ fmt(orderPayable) }}</span>
      </div>
      <div class="np-field">
        <span class="np-field-label">优惠类型</span>
        <a-radio-group v-model="discountType" class="touch-radio" button-style="solid" size="large">
          <a-radio-button value="change">改价</a-radio-button>
          <a-radio-button value="discount">折扣</a-radio-button>
          <a-radio-button value="erase">抹零</a-radio-button>
        </a-radio-group>
      </div>
      <template v-if="discountType === 'change'">
        <div class="np-field">
          <span class="np-field-label"><i class="req">*</i>实付价格</span>
          <div class="np-suffix-row">
            <a-input v-model="discountChangeValue" readonly placeholder="0.00" class="np-input" />
            <span class="np-suffix">元</span>
          </div>
        </div>
        <num-pad v-model="discountChangeValue" @confirm="confirmDiscount" />
      </template>
      <template v-else-if="discountType === 'discount'">
        <div class="np-field">
          <span class="np-field-label"><i class="req">*</i>优惠折扣</span>
          <div class="np-suffix-row">
            <a-input v-model="discountRateInput" readonly placeholder="如 7 表示 7 折" class="np-input" />
            <span class="np-suffix">折</span>
          </div>
        </div>
        <div class="discount-hint">折后应付：¥{{ discountedPreview }}</div>
        <num-pad v-model="discountRateInput" :dot="false" @confirm="confirmDiscount" />
      </template>
      <template v-else-if="discountType === 'erase'">
        <div class="erase-btns">
          <div role="button" class="erase-btn" :class="{ active: discountEraseRule === 1 }" @click="discountEraseRule = 1">抹分</div>
          <div role="button" class="erase-btn" :class="{ active: discountEraseRule === 2 }" @click="discountEraseRule = 2">抹角</div>
          <div role="button" class="erase-btn" :class="{ active: discountEraseRule === 3 }" @click="discountEraseRule = 3">四舍五入到角</div>
          <div role="button" class="erase-btn" :class="{ active: discountEraseRule === 4 }" @click="discountEraseRule = 4">四舍五入到元</div>
        </div>
        <div class="erase-result">抹零后应付：<span class="np-green">¥{{ erasePreview }}</span></div>
      </template>
      <div v-else class="side-hint">请选择优惠类型</div>
      <div class="discount-footer" slot="footer">
        <a-button :loading="discountLoading" @click="clearDiscount">清除优惠</a-button>
        <a-button v-if="discountType === 'erase'" type="primary" :loading="discountLoading"
                  @click="confirmDiscount">确定</a-button>
      </div>
    </a-modal>

    <!-- 整单清空弹窗（cashier-touch-v2：必选备注→订单作废+释放桌台，还原未就餐） -->
    <a-modal title="整单清空" :visible="clearVisible" :maskClosable="false" width="520px"
             :confirm-loading="clearLoading" ok-text="确认清空" ok-type="danger"
             @ok="confirmClear" @cancel="clearVisible = false">
      <div class="clear-tip">
        清空后整单作废并释放桌台（还原为未就餐状态），此操作不可恢复，请谨慎操作！<br>
        作废后将打印作废通知单至厨房与传菜部。
      </div>
      <div class="np-field">
        <span class="np-field-label"><i class="req">*</i>清空原因</span>
        <a-select v-model="clearRemark" placeholder="请选择常用清空原因" style="width: 100%"
                  :getPopupContainer="trigger => trigger.parentElement">
          <a-select-option v-for="r in clearReasons" :key="r" :value="r">{{ r }}</a-select-option>
        </a-select>
      </div>
      <div class="np-field">
        <span class="np-field-label">自定义原因</span>
        <a-input v-model="clearCustomRemark" placeholder="或直接输入自定义原因（优先于下拉选择）"
                 :maxLength="100" />
      </div>
    </a-modal>

    <!-- 预收订金弹窗（cashier-touch-v2：已预收+本次预收+NumPad，确认累加） -->
    <a-modal title="预收订金" :visible="depositVisible" :footer="null" width="520px"
             :maskClosable="false" @cancel="depositVisible = false">
      <div class="np-field">
        <span class="np-field-label">已预收金额</span>
        <span class="np-field-value np-blue">¥{{ fmt(depositTotal) }}</span>
      </div>
      <div class="np-field">
        <span class="np-field-label"><i class="req">*</i>本次预收</span>
        <div class="np-suffix-row">
          <a-input v-model="depositValue" readonly placeholder="0.00" class="np-input" />
          <span class="np-suffix">元</span>
        </div>
      </div>
      <div class="member-tip">客人提前在收银台预存的金额，餐后结算时自动抵扣应付</div>
      <num-pad v-model="depositValue" @confirm="confirmDeposit" />
    </a-modal>

    <!-- 退菜弹窗（理由必填，确认后触发 TCD 退菜单打印） -->
    <return-item-modal :visible="returnVisible"
                       :item-name="returnTarget ? returnTarget.material_name : ''"
                       :loading="returnLoading"
                       @cancel="returnVisible = false" @confirm="confirmReturn" />
    <!-- 打印弹窗（预结单 YJD / 结账单 JZD，autoPrint 开启时静默打印） -->
    <print-modal ref="printModal" />
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from '@/api/manage'
import { areaList, tableTypeList, tableList, orderList, orderCreate, orderDetail,
  orderSetDiscount, orderClearItems, orderBindMember, orderDeposit, orderItemReturn } from '@/api/plugin/dining'
import { memberList } from '@/api/plugin/member'
import NumPad from './components/NumPad.vue'
import PrintModal from './PrintModal'
import ReturnItemModal from './components/ReturnItemModal.vue'

const POLL_INTERVAL = 15000 // 15s 轮询（照一期）
const PREFIX = '/api/plugin/dining'

/**
 * 堂食视图（/cashier/dining/table，Task 6.2-6.5 克隆云贝截图3逐元素）：
 * 区域 Tab → 桌型过滤（名称(桌数)）→ 桌台卡网格（灰未开台"N座"/绿已开台/橙就餐中"时长+人数+座位"）
 * + 右侧信息面板（桌台/人数/订单来源/当前订单）+ 底部状态栏（三色图例+刷新+结算/点餐模式+协助点餐）。
 * 桌台数据：GET /table/list 聚合（区域/桌型/当前订单联查）；就餐时长/金额由前端按订单 create_time 计算
 * （board 聚合接口后端待补）；开台 POST /order（people/orderSource，orderSource 后端暂忽略）；
 * cashier-touch-v2：四弹窗（会员/改价/折扣抹零/转台）按云贝截图触屏化（NumPad/三级级联），
 * 整单清空=必选备注作废+释放桌台，预收订金 PUT /order/{id}/deposit 累加、结算抵扣。
 */
export default {
  name: 'CashierTableView',
  components: { NumPad, PrintModal, ReturnItemModal },
  props: {
    storeId: { type: Number, required: true },
    storeName: { type: String, default: '' }
  },
  data() {
    return {
      areas: [],
      tableTypes: [],
      tables: [],
      orderRows: [],
      activeArea: 0,
      activeType: 0,
      selectedTableId: null,
      selectedOrder: null,
      detailLoading: false,
      instore: {},
      loading: false,
      openVisible: false,
      openTable: null,
      openPeople: 1,
      openSource: '服务员开台',
      opening: false,
      orderSources: ['扫码点餐', '协助点餐', '服务员开台'],
      changeVisible: false,
      changeAreaId: undefined,
      changeTypeId: undefined,
      changeTargetId: null,
      changing: false,
      receiving: false,
      // 底部功能栏：明细行选中（商品改价定位）
      selectedItemId: null,
      // 会员弹窗（三态：输入查询 → 预览确定绑定 → 已绑解绑）
      memberVisible: false,
      memberPhone: '',
      memberLoading: false,
      boundMemberInfo: null,
      memberQueryResult: null,
      // 商品改价弹窗（云贝图2：NumPad 字符串输入）
      priceVisible: false,
      priceValue: '',
      priceLoading: false,
      // 折扣抹零弹窗（云贝图3/4：三选一互斥，NumPad 字符串输入）
      discountVisible: false,
      discountType: '',
      discountChangeValue: '',
      discountRateInput: '',
      discountEraseRule: 1,
      discountLoading: false,
      // 整单清空弹窗（必选备注→订单作废+释放桌台）
      clearVisible: false,
      clearRemark: undefined,
      clearCustomRemark: '',
      clearLoading: false,
      clearReasons: [
        '开单错误，整单重开',
        '重复开单，作废其中一单',
        '顾客取消用餐，未消费',
        '顾客换桌，原单清空',
        '系统异常，订单作废重开',
        '误开空单，顾客未点餐',
        '套餐变更，原单作废',
        '测试单据，内部测试开单后清空',
        '顾客改套餐，原整单作废重新点单',
        '顾客临时取消用餐，未上菜',
        '菜品点错、整单全部重开',
        '开单错误，桌号选错'
      ],
      // 预收订金弹窗
      depositVisible: false,
      depositValue: '',
      depositLoading: false,
      // 退菜弹窗（Task 8：理由必填，触发 TCD）
      returnVisible: false,
      returnLoading: false,
      returnTarget: null,
      pollTimer: null
    }
  },
  watch: {
    // 扫码枪/NumPad 输满 11 位手机号自动查询（扫码即查，无需点确认）
    memberPhone(v) {
      if (this.memberVisible && !this.memberQueryResult && /^\d{11}$/.test(v || '')) {
        this.searchMemberByPhone()
      }
    }
  },
  computed: {
    // 订单索引：orderId → 订单行（就餐时长/金额由 create_time 计算）
    orderMap() {
      const map = {}
      this.orderRows.forEach(o => { map[o.id] = o })
      return map
    },
    // 桌型过滤 Tab：名称(该型桌数)——仅展示有桌台的桌型
    typeTabs() {
      return this.tableTypes
        .map(tt => ({ ...tt, count: this.tables.filter(t => t.tableTypeId === tt.id).length }))
        .filter(tt => tt.count > 0)
    },
    filteredTables() {
      return this.tables.filter(t =>
        (this.activeArea === 0 || t.areaId === this.activeArea) &&
        (this.activeType === 0 || t.tableTypeId === this.activeType))
    },
    idleTables() {
      return this.tables.filter(t => t.status === '1')
    },
    // 转台级联第2级：所选区域内有空闲桌的桌型（名称(座位数)）
    changeTypeOptions() {
      if (!this.changeAreaId) return []
      const idleInArea = this.idleTables.filter(t => t.areaId === this.changeAreaId)
      const typeIds = {}
      idleInArea.forEach(t => { typeIds[t.tableTypeId] = true })
      return this.tableTypes
        .filter(tt => typeIds[tt.id])
        .map(tt => ({ ...tt, count: idleInArea.filter(t => t.tableTypeId === tt.id).length }))
    },
    // 转台级联第3级：区域+桌型均匹配的空闲桌
    changeTableOptions() {
      if (!this.changeAreaId || !this.changeTypeId) return []
      return this.idleTables.filter(t =>
        t.areaId === this.changeAreaId && t.tableTypeId === this.changeTypeId)
    },
    // 已预收订金合计（订金弹窗展示；结算前实时取订单落库值）
    depositTotal() {
      return this.selectedOrder ? Number(this.selectedOrder.deposit_money || 0) : 0
    },
    selectedTable() {
      return this.tables.find(t => t.id === this.selectedTableId) || null
    },
    payModeText() {
      return this.instore.payMode === '2' ? '先用餐后结账' : '先结账后用餐'
    },
    orderModeText() {
      return this.instore.orderMode === '2' ? '拼桌点餐' : '多人点餐'
    },
    // 手动接单可见性：订单 '1' 待接单 + 店内设置 receiving='2'（手动接单）
    canReceive() {
      return !!this.selectedOrder && this.selectedOrder.status === '1' &&
        String(this.instore.receiving) === '2'
    },
    // 当前订单基础应付（合计+服务费+餐位费-会员折扣-整单优惠-抹零；未结算 pay_amount=0 用 total 近似）
    orderPayable() {
      const o = this.selectedOrder
      if (!o) return 0
      const total = Number(o.total_amount || 0) + Number(o.service_money || 0) + Number(o.tableware_money || 0)
      return Math.max(0, total - Number(o.discount_amount || 0) - Number(o.erase_amount || 0))
    },
    // 折后预览：折扣输入 7 表示 7 折
    discountedPreview() {
      const rate = Number(this.discountRateInput || 0) / 10
      return (this.orderPayable * rate).toFixed(2)
    },
    // 抹零后预览：1抹分 2抹角 3四舍五入到角 4四舍五入到元
    erasePreview() {
      const v = this.orderPayable
      let r = v
      if (this.discountEraseRule === 1) r = Math.floor(v * 10) / 10
      else if (this.discountEraseRule === 2) r = Math.floor(v)
      else if (this.discountEraseRule === 3) r = Math.round(v * 10) / 10
      else r = Math.round(v)
      return r.toFixed(2)
    },
    // 改价目标行（右侧点选的明细）
    priceItem() {
      if (!this.selectedOrder || !this.selectedOrder.items || !this.selectedItemId) return null
      return this.selectedOrder.items.find(it => it.id === this.selectedItemId) || null
    },
    // 会员标签（绑定后显示；刷新后兜底）
    boundMember() {
      if (this.boundMemberInfo) return this.boundMemberInfo.name
      return this.selectedOrder && this.selectedOrder.member_id ? '已绑会员' : ''
    }
  },
  created() {
    this.refreshAll()
    this.loadInstore()
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  beforeDestroy() {
    this.stopPolling()
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  },
  methods: {
    fmt(v) {
      return Number(v || 0).toFixed(2)
    },
    // 就餐人数：订单 people → person_count → 座位数兜底
    peopleOf(t) {
      const order = t.orderId ? this.orderMap[t.orderId] : null
      return (order && (order.people || order.person_count)) || t.personCount || t.capacity || '-'
    },
    // 订单来源：后端暂无 order_source 字段（开台来源仅前端选择），待后端补字段后回显
    sourceOf() {
      return '—'
    },
    cardClass(t) {
      return { '1': 's-idle', '2': 's-open', '3': 's-dining', reserved: 's-reserved' }[t.status] || 's-idle'
    },
    orderTagColor(status) {
      return { '1': 'orange', '2': 'green', '3': 'blue', '5': 'red', parked: 'purple' }[status] || 'default'
    },
    // 桌台+区域+桌型+近 100 笔订单（联查金额/时长），15s 轮询（页面隐藏停止）
    refreshAll() {
      this.loading = true
      Promise.all([
        areaList({ storeId: this.storeId }),
        tableTypeList({ storeId: this.storeId }),
        tableList({ storeId: this.storeId }),
        orderList({ storeId: this.storeId, currentPage: 1, pageSize: 100 })
      ]).then(([areas, types, tables, orders]) => {
        if (areas.code === 200 && areas.data) this.areas = areas.data || []
        if (types.code === 200 && types.data) this.tableTypes = types.data || []
        if (orders.code === 200 && orders.data && orders.data.rows) this.orderRows = orders.data.rows || []
        if (tables.code === 200 && tables.data) {
          this.tables = (tables.data || []).map(t => ({
            ...t,
            diningMinutes: this.minutesOf(t)
          }))
          this.refreshSelectedDetail()
        }
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
      this.startPolling()
    },
    // 就餐时长（分钟）= 当前活跃订单 create_time 距今（兼容毫秒数值/ISO 字符串/yyyy-MM-dd HH:mm:ss）
    minutesOf(t) {
      const order = t.orderId ? this.orderMap[t.orderId] : null
      const created = this.parseTime(order && order.create_time)
      if (!created) return '-'
      return Math.max(0, Math.floor((Date.now() - created.getTime()) / 60000))
    },
    parseTime(v) {
      if (v === null || v === undefined) return null
      if (typeof v === 'number') return new Date(v)
      const m = String(v).match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})[T ](\d{1,2}):(\d{1,2}):(\d{1,2})/)
      if (m) {
        return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6])
      }
      return null
    },
    // 店内设置（底部状态栏文案）：GET /store-setting/instore
    loadInstore() {
      getAction(`${PREFIX}/store-setting/instore`, { storeId: this.storeId }).then(res => {
        if (res.code === 200 && res.data) {
          this.instore = res.data
        }
      }).catch(() => {})
    },
    startPolling() {
      this.stopPolling()
      this.pollTimer = setInterval(() => {
        if (!document.hidden) this.refreshData()
      }, POLL_INTERVAL)
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    // 轮询静默刷新（不重置区域/桌型筛选，不闪 loading）
    refreshData() {
      Promise.all([
        tableList({ storeId: this.storeId }),
        orderList({ storeId: this.storeId, currentPage: 1, pageSize: 100 })
      ]).then(([tables, orders]) => {
        if (orders.code === 200 && orders.data && orders.data.rows) this.orderRows = orders.data.rows || []
        if (tables.code === 200 && tables.data) {
          this.tables = (tables.data || []).map(t => ({ ...t, diningMinutes: this.minutesOf(t) }))
          this.refreshSelectedDetail()
        }
      }).catch(() => {})
    },
    onVisibilityChange() {
      if (!document.hidden) {
        this.refreshData()
      }
    },
    // 桌台点击：未开台/已预订 → 开台弹窗；已开台/就餐中 → 右侧面板选中并加载当前订单
    onTableClick(t) {
      if (t.status === '1' || t.status === 'reserved') {
        this.openTableModal(t)
      } else {
        this.selectedTableId = t.id
        this.refreshSelectedDetail()
      }
    },
    openTableModal(t) {
      this.openTable = t
      this.openPeople = t.capacity > 0 ? t.capacity : 1
      this.openSource = '服务员开台'
      this.openVisible = true
    },
    // 开台：POST /order（people/personCount + orderSource 前端先传后端忽略）→ 进点餐
    confirmOpen() {
      if (this.opening || !this.openTable) return
      this.opening = true
      orderCreate({
        storeId: this.storeId,
        orderType: 'dine_in',
        tableId: this.openTable.id,
        people: this.openPeople,
        personCount: this.openPeople,
        orderSource: this.openSource
      }).then(res => {
        if (res.code === 200 && res.data) {
          this.openVisible = false
          this.gotoOrder(this.openTable.id, res.data.id)
        } else {
          this.$message.error(res.message || '开台失败')
          this.refreshData()
        }
      }).catch(() => {
        this.$message.error('开台失败，请重试')
      }).finally(() => {
        this.opening = false
      })
    },
    // 选中桌当前订单详情（菜品/金额/状态）；同订单轮询刷新保留已绑定会员卡与明细行选中
    refreshSelectedDetail() {
      const t = this.selectedTable
      if (!t) return
      const prevItemId = this.selectedItemId
      if (!t.orderId) {
        this.selectedOrder = null
        this.boundMemberInfo = null
        this.selectedItemId = null
        return
      }
      if (!this.selectedOrder || this.selectedOrder.id !== t.orderId) {
        this.boundMemberInfo = null
        this.selectedItemId = null
      }
      this.detailLoading = true
      orderDetail(t.orderId).then(res => {
        if (res.code === 200 && res.data) {
          this.selectedOrder = res.data
          // 轮询刷新后仍存在的选中明细行保持选中（改价定位不因刷新丢失）
          if (prevItemId && res.data.items &&
              res.data.items.some(it => it.id === prevItemId)) {
            this.selectedItemId = prevItemId
          }
        }
      }).catch(() => {}).finally(() => {
        this.detailLoading = false
      })
    },
    gotoOrder(tableId, orderId) {
      this.stopPolling()
      this.$router.push(`/cashier/dining/order/${tableId}?orderId=${orderId}&storeId=${this.storeId}`)
    },
    gotoSettle(orderId) {
      this.stopPolling()
      this.$router.push(`/cashier/dining/settle/${orderId}`)
    },
    // 手动接单（Task 7.3）：契约接口 POST /order/{id}/receive 推进 '2'+receipt_at（后端待补）
    handleReceive() {
      if (this.receiving || !this.selectedOrder) return
      this.receiving = true
      postAction(`${PREFIX}/order/${this.selectedOrder.id}/receive`).then(res => {
        if (res.code === 200) {
          this.$message.success('接单成功')
          this.refreshSelectedDetail()
          this.refreshData()
        } else {
          this.$message.error(res.message || '接单失败')
        }
      }).catch(() => {
        this.$message.error('接单失败，请重试')
      }).finally(() => {
        this.receiving = false
      })
    },
    // 协助点餐：收银员代顾客在选中桌台开单点餐（同一订单链路，完整能力 Task 7）
    assistOrder() {
      const t = this.selectedTable
      if (t && t.orderId && (t.status === '2' || t.status === '3')) {
        this.gotoOrder(t.id, t.orderId)
      } else {
        this.$message.warning('请先点选已开台桌台，再协助点餐')
      }
    },
    // 转台（云贝图5 三级级联）：打开时默认定位当前桌所在区域，减少点击
    openChangeModal() {
      if (!this.requireOrder()) return
      const t = this.selectedTable
      this.changeAreaId = (t && t.areaId) || undefined
      this.changeTypeId = undefined
      this.changeTargetId = null
      this.changeVisible = true
    },
    // 级联：切区域清空桌型/桌台
    onChangeArea() {
      this.changeTypeId = undefined
      this.changeTargetId = null
    },
    // 级联：切桌型清空桌台
    onChangeType() {
      this.changeTargetId = null
    },
    // 转台：POST /order/{id}/change-table body {tableId}；原桌释放、新桌就餐中、订单号不变
    confirmChange() {
      if (this.changing) return
      if (!this.changeAreaId || !this.changeTypeId || !this.changeTargetId) {
        this.$message.warning('请依次选择区域、桌位类型与空闲桌台')
        return
      }
      this.changing = true
      postAction(`${PREFIX}/order/${this.selectedOrder.id}/change-table`, { tableId: this.changeTargetId })
        .then(res => {
          if (res.code === 200) {
            this.$message.success('转台成功，已打印换桌单通知传菜部')
            this.changeVisible = false
            this.selectedTableId = this.changeTargetId
            this.refreshData()
          } else {
            this.$message.error(res.message || '转台失败')
          }
        }).catch(() => {
          this.$message.error('转台失败，请重试')
        }).finally(() => {
          this.changing = false
        })
    },
    // ==================== 底部功能栏 ====================
    // 前置校验：需选中就餐中/已开台桌台的未结算订单
    requireOrder() {
      if (!this.selectedOrder) {
        this.$message.warning('请先点选就餐中桌台')
        return null
      }
      return this.selectedOrder
    },
    // ==================== 退菜（Task 8：理由必填→TCD 退菜单） ====================
    isReturned(it) {
      return String(it.return_status) === '1'
    },
    openReturnModal(it) {
      if (!this.selectedOrder) return
      this.returnTarget = it
      this.returnVisible = true
    },
    confirmReturn(reason) {
      const o = this.selectedOrder
      const it = this.returnTarget
      if (this.returnLoading || !o || !it) return
      this.returnLoading = true
      orderItemReturn(o.id, it.id, { reason }).then(res => {
        if (res.code === 200) {
          this.$message.success('退菜成功，已打印退菜单通知厨房')
          this.returnVisible = false
          this.refreshSelectedDetail()
          this.refreshData()
        } else {
          this.$message.error(res.message || '退菜失败')
        }
      }).catch(() => {
        this.$message.error('退菜失败，请重试')
      }).finally(() => {
        this.returnLoading = false
      })
    },
    // 整单清空（cashier-touch-v2 重定义）：必选备注弹窗 → 订单作废+释放桌台（还原未就餐）
    handleClearAll() {
      if (!this.requireOrder()) return
      this.clearRemark = undefined
      this.clearCustomRemark = ''
      this.clearVisible = true
    },
    confirmClear() {
      const o = this.selectedOrder
      if (this.clearLoading || !o) return
      const remark = (this.clearCustomRemark || '').trim() || this.clearRemark
      if (!remark) {
        this.$message.warning('请选择或输入清空原因')
        return
      }
      this.clearLoading = true
      orderClearItems(o.id, { remark }).then(res => {
        if (res.code === 200) {
          this.$message.success('整单已清空，桌台已还原未就餐')
          this.clearVisible = false
          this.selectedOrder = null
          this.selectedItemId = null
          this.refreshData()
        } else {
          this.$message.error(res.message || '清空失败')
        }
      }).catch(() => {
        this.$message.error('清空失败，请重试')
      }).finally(() => {
        this.clearLoading = false
      })
    },
    // 会员弹窗（三态）：打开回填已绑会员档案；未绑进入扫码/NumPad 查询输入态
    openMemberModal() {
      if (!this.requireOrder()) return
      this.memberPhone = ''
      this.memberQueryResult = null
      const o = this.selectedOrder
      if (o && o.member_id && o.memberInfo) {
        this.boundMemberInfo = { ...o.memberInfo }
      }
      this.memberVisible = true
      this.$nextTick(() => {
        if (this.$refs.memberPhoneInput) this.$refs.memberPhoneInput.focus()
      })
    },
    // 查询（扫码枪满 11 位/回车/NumPad 确认触发）：命中仅预览，确认后才绑定
    searchMemberByPhone() {
      const o = this.selectedOrder
      const phone = (this.memberPhone || '').trim()
      if (this.memberLoading || !o) return
      if (!/^1\d{10}$/.test(phone)) {
        this.$message.warning('请输入 11 位会员手机号')
        return
      }
      this.memberLoading = true
      memberList({ search: JSON.stringify({ telephone: phone }), currentPage: 1, pageSize: 20 }).then(res => {
        if (res.code === 200 && res.data) {
          const rows = res.data.rows || []
          if (rows.length === 0) {
            this.$message.warning('未查询到该会员')
            return
          }
          const record = rows[0]
          this.memberQueryResult = {
            memberId: record.memberId,
            name: record.supplier,
            phone: record.phoneNum,
            levelName: record.levelName,
            balance: record.advanceIn
          }
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch(() => {
        this.$message.error('查询会员失败，请重试')
      }).finally(() => {
        this.memberLoading = false
      })
    },
    // 预览态「确定」：绑定会员
    confirmBindMember() {
      const o = this.selectedOrder
      const q = this.memberQueryResult
      if (this.memberLoading || !o || !q) return
      this.memberLoading = true
      orderBindMember(o.id, { memberId: q.memberId }).then(res => {
        if (res.code === 200) {
          this.$message.success(`已绑定会员：${q.name}`)
          this.boundMemberInfo = (res.data && res.data.member) ? {
            name: res.data.member.name,
            phone: res.data.member.phone,
            levelName: res.data.member.levelName,
            balance: res.data.member.balance
          } : { ...q }
          this.memberQueryResult = null
          this.refreshSelectedDetail()
        } else {
          this.$message.error(res.message || '绑定失败')
        }
      }).catch(() => {
        this.$message.error('绑定会员失败，请重试')
      }).finally(() => {
        this.memberLoading = false
      })
    },
    // 预览态「取消」：清空回输入态并聚焦（可重新扫码）
    cancelMemberQuery() {
      this.memberQueryResult = null
      this.memberPhone = ''
      this.$nextTick(() => {
        if (this.$refs.memberPhoneInput) this.$refs.memberPhoneInput.focus()
      })
    },
    unbindMember() {
      const o = this.selectedOrder
      if (!o) return
      this.memberLoading = true
      orderBindMember(o.id, { memberId: null }).then(res => {
        if (res.code === 200) {
          this.$message.success('已解绑会员')
          this.boundMemberInfo = null
          this.memberVisible = false
          this.refreshSelectedDetail()
        } else {
          this.$message.error(res.message || '解绑失败')
        }
      }).catch(() => {
        this.$message.error('解绑失败，请重试')
      }).finally(() => {
        this.memberLoading = false
      })
    },
    // 商品改价（云贝图2）：当前价格 + NumPad 本次售价；需先点选右侧明细行（已退行不可改价）
    openChangePriceModal() {
      if (!this.requireOrder()) return
      if (!this.priceItem) {
        this.$message.warning('请先在右侧点选要改价的菜品行')
        return
      }
      if (this.isReturned(this.priceItem)) {
        this.$message.warning('已退菜品不能改价')
        return
      }
      this.priceValue = ''
      this.priceVisible = true
    },
    confirmChangePrice() {
      const o = this.selectedOrder
      const item = this.priceItem
      if (this.priceLoading || !o || !item) return
      const price = Number(this.priceValue)
      if (!this.priceValue || isNaN(price) || price < 0) {
        this.$message.warning('请输入正确的本次售价')
        return
      }
      this.priceLoading = true
      postAction(`${PREFIX}/order/items/${item.id}/change-price`, { unitPrice: price })
        .then(res => {
          if (res.code === 200) {
            this.$message.success('改价成功')
            this.priceVisible = false
            this.refreshSelectedDetail()
            this.refreshData()
          } else {
            this.$message.error(res.message || '改价失败')
          }
        }).catch(() => {
          this.$message.error('改价失败，请重试')
        }).finally(() => {
          this.priceLoading = false
        })
    },
    // 折扣抹零（云贝图3/4 三选一互斥）：打开时按订单预存优惠初始化
    openDiscountModal() {
      const o = this.requireOrder()
      if (!o) return
      this.discountType = o.discount_type || ''
      this.discountChangeValue = ''
      this.discountRateInput = ''
      this.discountEraseRule = o.discount_type === 'erase' && o.discount_value ? Number(o.discount_value) : 1
      this.discountVisible = true
    },
    confirmDiscount() {
      const o = this.selectedOrder
      if (this.discountLoading || !o) return
      let body
      if (this.discountType === 'change') {
        const changeTo = Number(this.discountChangeValue)
        if (!this.discountChangeValue || isNaN(changeTo) || changeTo < 0) {
          this.$message.warning('请输入实付价格')
          return
        }
        body = { type: 'change', value: changeTo }
      } else if (this.discountType === 'discount') {
        const rate = Number(this.discountRateInput)
        if (!this.discountRateInput || isNaN(rate) || rate < 0.1 || rate > 9.9) {
          this.$message.warning('请输入 0.1-9.9 的折扣（如 7 表示 7 折）')
          return
        }
        body = { type: 'discount', value: rate / 10 }
      } else if (this.discountType === 'erase') {
        body = { type: 'erase', value: this.discountEraseRule }
      } else {
        this.$message.warning('请选择优惠类型')
        return
      }
      this.discountLoading = true
      orderSetDiscount(o.id, body).then(res => {
        if (res.code === 200) {
          this.$message.success('优惠已设置')
          this.discountVisible = false
          this.refreshSelectedDetail()
        } else {
          this.$message.error(res.message || '设置失败')
        }
      }).catch(() => {
        this.$message.error('设置优惠失败，请重试')
      }).finally(() => {
        this.discountLoading = false
      })
    },
    clearDiscount() {
      const o = this.selectedOrder
      if (this.discountLoading || !o) return
      this.discountLoading = true
      orderSetDiscount(o.id, { type: 'none' }).then(res => {
        if (res.code === 200) {
          this.$message.success('优惠已清除')
          this.discountVisible = false
          this.refreshSelectedDetail()
        } else {
          this.$message.error(res.message || '清除失败')
        }
      }).catch(() => {
        this.$message.error('清除优惠失败，请重试')
      }).finally(() => {
        this.discountLoading = false
      })
    },
    // 预收订金（cashier-touch-v2）：NumPad 输入本次预收 → 确认累加落库（餐后结算抵扣）
    openDepositModal() {
      if (!this.requireOrder()) return
      this.depositValue = ''
      this.depositVisible = true
    },
    confirmDeposit() {
      const o = this.selectedOrder
      if (this.depositLoading || !o) return
      const amount = Number(this.depositValue)
      if (!this.depositValue || isNaN(amount) || amount <= 0) {
        this.$message.warning('请输入正确的预收金额')
        return
      }
      this.depositLoading = true
      orderDeposit(o.id, { amount }).then(res => {
        if (res.code === 200) {
          this.$message.success(`预收成功，已累计预收 ¥${this.fmt(res.data.depositMoney)}`)
          this.depositVisible = false
          this.refreshSelectedDetail()
        } else {
          this.$message.error(res.message || '预收失败')
        }
      }).catch(() => {
        this.$message.error('预收订金失败，请重试')
      }).finally(() => {
        this.depositLoading = false
      })
    },
    // 打印预结单（autoPrint 开启→静默打印，否则弹预览；打印调用 fire-and-forget）
    async handlePrintPreSettle() {
      const o = this.requireOrder()
      if (!o) return
      if (await PrintModal.isAutoPrintEnabled()) {
        this.$refs.printModal.printSilent(o.id, 'pre_settle')
      } else {
        this.$refs.printModal.show(o.id, 'pre_settle')
      }
    },
    // 结账（底部功能栏主操作）
    handleSettle() {
      const o = this.requireOrder()
      if (!o) return
      this.gotoSettle(o.id)
    }
  }
}
</script>

<style scoped>
.table-view {
  flex: 1;
  display: flex;
  min-height: 0;
}
.tv-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 12px 12px 0 14px;
}
/* 筛选行（云贝：区域一行排布，桌型过滤居中偏左） */
.tv-filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 24px;
  flex-shrink: 0;
  margin-bottom: 10px;
}
/* 区域 Tab 组 */
.tv-area-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.area-pill {
  padding: 5px 18px;
  border-radius: 16px;
  background: #fff;
  color: #4a5261;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid #e4e7ed;
  transition: all 0.2s;
}
.area-pill:hover {
  border-color: #1890ff;
  color: #1890ff;
}
.area-pill.active {
  background: #1890ff;
  border-color: #1890ff;
  color: #fff;
}
/* 桌型过滤组（居中偏左） */
.tv-type-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: 16px;
}
.type-pill {
  padding: 3px 12px;
  border-radius: 4px;
  background: #fff;
  color: #7a8494;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid #e4e7ed;
}
.type-pill:hover {
  border-color: #1890ff;
  color: #1890ff;
}
.type-pill.active {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}
/* 桌台卡网格 */
.tv-grid-scroll {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
.tv-loading {
  font-size: 22px;
  color: #1890ff;
  margin: 20px auto;
  display: block;
  text-align: center;
}
.tv-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(138px, 1fr));
  gap: 12px;
  padding-bottom: 12px;
}
.tcard {
  border-radius: 10px;
  padding: 12px 12px 10px;
  min-height: 92px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  user-select: none;
  transition: box-shadow 0.2s, transform 0.15s;
  border: 2px solid transparent;
}
.tcard:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.14);
  transform: translateY(-1px);
}
.tcard.selected {
  border-color: #1890ff;
}
.tcard-name {
  font-size: 19px;
  font-weight: 700;
  line-height: 1.2;
}
.tcard-seats {
  margin-top: auto;
  font-size: 13px;
  align-self: flex-start;
}
.tcard-status {
  font-size: 14px;
  font-weight: 600;
  margin-top: 4px;
}
.tcard-sub {
  font-size: 12px;
  margin-top: 3px;
  opacity: 0.92;
}
/* 三色卡片：灰=未开台 / 绿=已开台 / 橙=就餐中（预订蓝） */
.s-idle {
  background: #eef0f3;
  color: #5a626e;
  box-shadow: inset 0 0 0 1px #e0e3e8;
}
.s-idle .tcard-seats {
  color: #98a0aa;
}
.s-open {
  background: #67c23a;
  color: #fff;
}
.s-dining {
  background: #ff9c42;
  color: #fff;
}
.s-reserved {
  background: #e6f7ff;
  color: #1890ff;
  box-shadow: inset 0 0 0 1px #91d5ff;
}
.tv-empty {
  color: #999;
  text-align: center;
  padding: 60px 0;
  font-size: 14px;
}
/* 底部状态栏 */
.tv-footer {
  flex-shrink: 0;
  height: 46px;
  margin: 0 -12px 0 -14px;
  padding: 0 14px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
}
.tv-legend {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #555c66;
}
.lg-item {
  display: inline-flex;
  align-items: center;
}
.lg-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
.lg-gray { background: #b9bfc8; }
.lg-green { background: #67c23a; }
.lg-orange { background: #ff9c42; }
.tv-foot-text {
  font-size: 13px;
  color: #4a5261;
}
/* 底部功能栏（云贝式上图标下文字，左操作/右主操作） */
.tv-actionbar {
  flex-shrink: 0;
  height: 64px;
  margin: 0 -12px 0 -14px;
  padding: 0 14px;
  background: #fff;
  border-top: 1px solid #eef1f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ab-left,
.ab-right {
  display: flex;
  align-items: center;
  gap: 6px;
}
.abtn {
  min-width: 64px;
  padding: 4px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-radius: 6px;
  cursor: pointer;
  color: #4a5261;
  transition: background 0.2s;
}
.abtn:hover {
  background: #f2f6ff;
}
.abtn-icon {
  font-size: 20px;
  line-height: 1;
}
.abtn-text {
  font-size: 12px;
  line-height: 1.2;
}
/* 右侧主操作（协助点餐/结账）云贝橙色系 */
.abtn-primary {
  color: #ff7f50;
}
.abtn-primary .abtn-icon {
  color: #ff7f50;
}
.abtn-primary:hover {
  background: #fff3ec;
}
.ab-right .abtn:last-child {
  color: #ff7f50;
  font-weight: 600;
}
/* 右侧信息面板（固定宽） */
.tv-side {
  width: 300px;
  flex-shrink: 0;
  background: #fff;
  border-left: 1px solid #e8ebf0;
  display: flex;
  flex-direction: column;
  padding: 14px 16px;
  overflow-y: auto;
}
.side-title {
  font-size: 16px;
  font-weight: 700;
  color: #262b33;
  flex-shrink: 0;
}
.side-info {
  margin-top: 10px;
  flex-shrink: 0;
}
.side-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #4a5261;
  padding: 5px 0;
}
.side-label {
  color: #98a0aa;
}
.side-order-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e4e7ed;
  flex-shrink: 0;
}
.side-order-no {
  font-size: 12px;
  color: #98a0aa;
  word-break: break-all;
}
.side-items {
  flex: 1;
  min-height: 40px;
  overflow-y: auto;
  margin-top: 6px;
}
.side-loading {
  display: block;
  text-align: center;
  color: #1890ff;
  margin-top: 14px;
}
.side-item {
  display: flex;
  align-items: baseline;
  font-size: 13px;
  color: #4a5261;
  padding: 5px 6px;
  margin: 0 -6px;
  border-radius: 4px;
  cursor: pointer;
}
.side-item:hover {
  background: #f7f9fc;
}
.side-item-active {
  background: #e6f7ff;
}
.si-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.si-qty {
  color: #98a0aa;
  margin: 0 8px;
}
.si-amount {
  color: #e4632a;
}
/* 已退行（Task 8）：置灰+划线+已退标签；未退行行内退菜按钮 */
.side-item-returned {
  cursor: default;
}
.side-item-returned .si-name,
.side-item-returned .si-qty {
  color: #c0c6cf;
  text-decoration: line-through;
}
.side-item-returned .si-amount {
  color: #c0c6cf;
  text-decoration: line-through;
}
.si-returned-tag {
  margin-left: 4px;
  margin-right: 0;
  flex-shrink: 0;
}
.si-return-btn {
  margin-left: 4px;
  padding: 0 6px;
  font-size: 12px;
  height: 22px;
  line-height: 20px;
  flex-shrink: 0;
}
.side-hint {
  font-size: 12px;
  color: #98a0aa;
  text-align: center;
  padding: 14px 0;
}
.side-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #4a5261;
  padding: 10px 0 4px;
  border-top: 1px dashed #e4e7ed;
  margin-top: 8px;
  flex-shrink: 0;
}
.side-total-amount {
  font-size: 18px;
  font-weight: 700;
  color: #e4632a;
}
.side-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0 4px;
  flex-shrink: 0;
}
.side-default {
  margin: auto;
  text-align: center;
  color: #98a0aa;
  font-size: 13px;
  padding: 0 16px;
  line-height: 1.8;
}
.side-default-icon {
  font-size: 34px;
  color: #cfd4db;
  display: block;
  margin-bottom: 10px;
}
/* 开台弹窗 */
.open-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.open-row {
  display: flex;
  align-items: center;
}
.open-label {
  width: 70px;
  color: #555c66;
  font-size: 13px;
}
/* 转台弹窗（三级级联） */
.change-tip {
  font-size: 13px;
  color: #98a0aa;
  margin-top: 12px;
}
.cascade-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 4px;
}
.cascade-row {
  display: flex;
  align-items: center;
}
.cascade-label {
  width: 90px;
  flex-shrink: 0;
  font-size: 14px;
  color: #4a5261;
}
/* 必填星号 */
.req {
  color: #f5222d;
  font-style: normal;
  margin-right: 2px;
}
/* 会员弹窗（云贝图1） */
.member-tip {
  font-size: 13px;
  color: #98a0aa;
  line-height: 1.7;
  margin-bottom: 16px;
}
.member-bound-hint {
  font-size: 13px;
  color: #d48806;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 6px;
  padding: 6px 12px;
  margin-bottom: 12px;
}
.member-card {
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.member-card-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.member-card-name {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.member-card-sub {
  justify-content: space-between;
  font-size: 13px;
  color: #6b7280;
}
/* 会员预览态：取消/确定 并排大按钮 */
.member-card-actions {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}
.member-card-actions .ant-btn {
  flex: 1;
}
/* NumPad 弹窗通用字段（改价/折扣抹零/订金） */
.np-field {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.np-field-label {
  width: 90px;
  flex-shrink: 0;
  font-size: 14px;
  color: #4a5261;
}
.np-field-value {
  font-size: 20px;
  font-weight: 700;
}
.np-blue {
  color: #1e78e8;
}
.np-green {
  color: #21a675;
}
.np-input-row {
  margin-bottom: 16px;
}
.np-input {
  height: 48px;
  font-size: 20px;
  font-weight: 600;
  border-radius: 8px;
}
.np-input-icon {
  color: #98a0aa;
  font-size: 18px;
}
.np-suffix-row {
  display: flex;
  align-items: center;
  flex: 1;
}
.np-suffix {
  flex-shrink: 0;
  margin-left: 8px;
  padding: 0 14px;
  height: 48px;
  line-height: 48px;
  background: #f2f4f7;
  border-radius: 0 8px 8px 0;
  color: #6b7280;
  font-size: 15px;
}
/* 折扣抹零（云贝图3/4） */
.touch-radio .ant-radio-button-wrapper {
  height: 44px;
  line-height: 42px;
  font-size: 15px;
  padding: 0 22px;
}
.discount-hint {
  font-size: 14px;
  color: #e4632a;
  font-weight: 600;
  margin-bottom: 12px;
}
.erase-btns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 14px;
}
.erase-btn {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 500;
  color: #4a5261;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  cursor: pointer;
}
.erase-btn.active {
  border-color: #1e78e8;
  background: #e6f2ff;
  color: #1e78e8;
}
.erase-result {
  font-size: 15px;
  color: #4a5261;
}
.discount-footer {
  text-align: right;
}
/* 整单清空弹窗 */
.clear-tip {
  font-size: 13px;
  color: #e4632a;
  line-height: 1.7;
  margin-bottom: 16px;
}
</style>
